import { render, staticRenderFns } from "./mySwiper.vue?vue&type=template&id=c132bcfc&scoped=true&"
import script from "./mySwiper.vue?vue&type=script&lang=js&"
export * from "./mySwiper.vue?vue&type=script&lang=js&"
import style0 from "./mySwiper.vue?vue&type=style&index=0&id=c132bcfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c132bcfc",
  null
  
)

export default component.exports